<section class="container" [formGroup]="form">
    <div class="card shadow-sm">
      <div class="card-header">
        <h3 class="card-title font-weight-semibold">
          <a href="/rota-volta" class="text-dark mr-2">
            <i class="fa fa-arrow-left"></i>
          </a>
          <span>Relatório de Folha</span>
        </h3>
      </div>
  
      <div class="card-body">
        <div class="row">

          <div class="col-md-4 form-group">
            <label>Competência *</label>
            <select class="form-control shadow-sm"
                    formControlName="competencia">
              <option value="">Selecione...</option>
              <option *ngFor="let comp of competencias"
                      [value]="comp.VALOR">
                {{ comp.DESCRICAO }}
              </option>
            </select>
          </div>

          <div class="col-md-4 form-group">
            <label>Tipo Folha *</label>
            <select class="form-control shadow-sm"
                    formControlName="tipoFolha">
              <option value="">Selecione...</option>
              <option *ngFor="let tipo of tiposFolha"
                      [value]="tipo.VALOR">
                {{ tipo.DESCICAO }}
              </option>
            </select>
          </div>

          <div class="col-md-4 form-group">
            <label>Lotação (Opcional)</label>
            <select class="form-control shadow-sm"
                    formControlName="lotacao">
              <option value="">TODAS...</option>
              <option *ngFor="let lot of lotacoes"
                      [value]="lot.VALOR">
               {{ lot.DESCRICAO }}
              </option>
            </select>
          </div>

          <div class="col-md-12 form-group">
            <h5>Vínculos</h5>

            <div class="row" formArrayName="vinculos">
              <div class="col-md-6 col-lg-4 form-group"
                   *ngFor="let v of vinculos; let i = index">
                <div class="custom-control custom-checkbox">

                  <input type="checkbox"
                         class="custom-control-input"
                         [id]="'vinc-'+i"
                         [formControlName]="i">
                  <label class="custom-control-label" [for]="'vinc-'+i">
                    {{ v.DESCRICAO }}
                  </label>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  
    <div class="card ng-star-inserted">
      <div class="card-header">
        <div class="text-right">
          <button type="button"
                  class="btn btn-success btn-lg"
                  [disabled]="form.invalid || loading"
                  (click)="gerarRelatorio()">
            <span class="mr-1">Gerar relatório</span>
            <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </section>
  